/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/scope */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { AiOutlineDashboard, AiOutlineShoppingCart } from "react-icons/ai";

import { get_customer_orders } from '../../store/reducers/orderReducer';

import Moment from 'moment';
import { currencyFormat } from '../CurrencyFormat';
import GetSellerConfig from '../GetSellerConfig';

const Orders = () => {
    //const { seller } = useSelector(state => state.seller)
    const { userInfo } = useSelector(state => state.auth)
    const { myOrders } = useSelector(state => state.order)
     
    const { 
        sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerBoolShowSitePayments
    } = GetSellerConfig();

    const [state, setState] = useState('all')
    const navigate = useNavigate()
    const dispatch = useDispatch()
    //const { orderId } = useParams()
    
    useEffect(() => {
        dispatch(get_customer_orders({customerId:userInfo.id, status:state}))
        //dispatch(get_customer_orders(orderId))
    },[state])

    const redirect = (ord) => {
        let items = 0;
        for (let i = 0; i < ord.products.length; i++) {
            items = ord.products[i].quantity + items; 
        }
        navigate('/payment',{
            state: {
                price: ord.price,
                items,
                orderId: ord._id 
            }
        }) 
    }

    return (
        <div className='bg-white rounded-2xl'>
            <div className='border p-4 rounded-2xl'
                style={{
                    backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight, 
                    color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                    borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                }}>
                <div className='flex justify-between items-center'>
                    <div className='text-2xl font-bold flex gap-1 mb-2 '>
                        <AiOutlineShoppingCart size={30} className='' /> My Orders
                    </div>
                    <select value={state} onChange={(e) => setState(e.target.value)} 
                        className='outline-none px-3 py-1 border rounded-md' 
                        style={{
                            color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                        }}>
                        <option value="all">--Order Status--</option>
                        <option value="placed">Placed</option>
                        <option value="pending">Pending</option>
                        <option value="cancelled">Cancelled</option>
                        <option className='hidden' value="warehouse">Warehouse</option>
                    </select> 
                </div>

                <div className='pt-4'>
                    <div className='relative overflow-x-auto rounded-md'>
                        <table className='w-full text-sm text-left' 
                            style={{
                                color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                                borderColor:sellerPrimaryColor1 + sellerColorSuffixDark,
                            }}>
                            <thead className='text-xs uppercase' 
                                style={{
                                    color:sellerPrimaryColor1, 
                                }}>
                                <tr>
                                    <th scope='col' className='hidden px-3 py-2'>Order Id</th>
                                    <th scope='col' className='px-3 py-1'>Date/Time</th>
                                    <th scope='col' className='px-3 py-1'>Order Type</th>
                                    <th scope='col' className={`${sellerBoolShowSitePayments ? 'px-3 py-1' : 'hidden'}`}>
                                        Price/Status
                                    </th>
                                    <th scope='col' className='px-3 py-2'>Order Status</th>
                                    <th scope='col' className='px-3 py-2'>Action</th> 
                                </tr>
                            </thead>
                            <tbody>
                            {
                                myOrders.map((o,i) => 
                                    <tr key={i} className='border'
                                        style={{
                                            backgroundColor:sellerPrimaryColor1 + sellerColorSuffixLight, 
                                            color:sellerPrimaryColor1 + sellerColorSuffixDark, 
                                            borderColor:sellerPrimaryColor1 + sellerColorSuffixDark
                                        }}>
                                        <td scope='row' className='hidden px-3 py-2 font-medium whitespace-nowrap'>#{o._id}</td>
                                        <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>
                                            <Link to={`/customerDashboard/order/details/${o._id}`}>
                                                {Moment(o.date).format('MM/DD/yyyy h:mm a')}
                                            </Link>
                                        </td> 
                                        <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>
                                            <Link to={`/customerDashboard/order/details/${o._id}`}>
                                                {o.orderType}
                                            </Link>
                                        </td> 
                                        <td scope='row' className={`${sellerBoolShowSitePayments ? 'px-3 py-2 font-medium whitespace-nowrap' : 'hidden'}`}>
                                            {currencyFormat.format(o.price)}/{o.payment_status }
                                        </td>
                                        <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>{o.delivery_status}</td>
                                        <td scope='row' className='px-3 py-2 font-medium whitespace-nowrap'>
                                            <Link to={`/customerDashboard/order/details/${o._id}`}>
                                                <span className='bg-green-200 text-green-800 text-md font-semibold mr-2 px-3 py-[2px] rounded'>
                                                    View
                                                </span>
                                            </Link>
                                            {
                                                o.payment_status !== 'paid' && sellerBoolShowSitePayments && 
                                                    <span onClick={() => redirect(o)} className='
                                                    hidden bg-green-200 text-green-800 text-md font-semibold mr-2 px-3 py-[2px] rounded cursor-pointer'>
                                                        Pay Now
                                                    </span> 
                                            }
                                        </td> 
                                    </tr>
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Orders;




